// src/App.js
import React, { Suspense, lazy, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./App.css";
import { isOperator } from "./utils/roles";
import { ScaleLoader } from "react-spinners";

import Home from "./views/Home";
import BusinessType from "./views/BusinessType";
import AssociatedCreators from "./views/AssociatedCreators";
import OwnerInformation from "./views/OwnerInformation";
import OwnerStatus from "./views/OwnerStatus";
import SectorActivity from "./views/SectorActivity";
import Procedure from "./views/Procedure";
import BusinessName from "./views/BusinessName";
import Oapi from "./views/Oapi";
import Options from "./views/Options";
import CompanySeat from "./views/CompanySeat";
import HaveBusinessName from "./views/HaveBusinessName";
import Domiciliation from "./views/Domiciliation";
import Bank from "./views/Bank";
import OtherServices from "./views/OtherServices";
import PlatformGest from "./views/PlatfomGest";
import PlatformAdmin from "./views/PlatformAdmin";
import PlatformGRH from "./views/PlatformGRH";
import PlatformSale from "./views/PlatformSale";
import Cart from "./views/Cart";
import Payment from "./views/Payment";
import Turnover from "./views/Turnover";
import EditPlatformGest from "./views/editCart/EditPlatfomGest";
import EditPlatformAdmin from "./views/editCart/EditPlatformAdmin";
import EditPlatformGRH from "./views/editCart/EditPlatformGRH";
import EditPlatformSale from "./views/editCart/EditPlatformSale";
import EditOapi from "./views/editCart/EditOapi";
import EditDomiciliation from "./views/editCart/EditDomiciliation";
import EditBank from "./views/editCart/EditBank";
import Finalization from "./views/Finalization";
import AdminLayout from "./layouts/AdminLayout";
import UserLayout from "./layouts/UserLayout";
import OperatorLayout from "./layouts/OperatorLayout";
import Login from "./views/auth/Login";
import Register from "./views/auth/Register";
import BusinessCountry from "./views/BusinessCountry";
import EditHaveBusinessName from "./views/editCart/EditHaveBusinessName";
import EditAssociatedCreators from "./views/editCart/EditAssociatedCreators";
import EditBusinessName from "./views/editCart/EditBusinessName";
import EditBusinessType from "./views/editCart/EditBusinessType";
import Formalities from "./views/formalities/Formalities";
import Banner from "./components/banner/Banner";
import OTP from "./views/OTP";
import ForgotPassword from "./views/auth/ForgotPassword";
import ForgotPasswordEmail from "./views/auth/ForgotPasswordEmail";
import AuthOPT from "./views/auth/AuthOTP";
import PlatformJuridique from "./views/PlatformJuridique";
import EditPlatformJuridique from "./views/editCart/EditPlatformJuridique";
import { useSelector } from "react-redux";
import Companies from "./views/Companies";
import BusinessAddress from "./views/BusinessAddress";
import CheckPayment from "./views/CheckPayment ";
import Documents from "./views/Documents";
import ManagerType from "./views/ManagerType";
import ManagerName from "./views/ManagerName";
import ManagerBusinessName from "./views/ManagerBusinessName";
import OwnerMaritalStatus from "./views/OwnerMaritalStatus";
import PrivacyPolicy from "./views/PrivacyPolicy";
import ShareCapital from "./views/ShareCapital";
import TermsAndConditions from "./views/TermsAndConditions";
import SectorActivityName from "./views/SectorActivityName";
import FormalityOTP from "./views/formalities/FormalityOTP";
import FormalityUserInformation from "./views/formalities/FormalityUserInformation";
import FormalityDocuments from "./views/formalities/FormalityDocuments";
import BirthPlace from "./views/formalities/crimRecord/BirthPlace";
import FormalityPayment from "./views/formalities/FormalityPayment";
import FormalityFinalization from "./views/formalities/FormalityFinalization";
import CertificateNationalityCountry from "./views/formalities/certificateNationality/CertificateNationalityCountry";
import CertificateSinglenessCountry from "./views/formalities/certificateSingleness/CertificateSingleness";
import EneoCountry from "./views/formalities/eneo/EneoCountry";
import EneoElectricityMeterType from "./views/formalities/eneo/EneoElectricityMeterType";
import CustomsRebateCountry from "./views/formalities/customsRebate/CustomsRebateCountry";
import CustomsRebateProductType from "./views/formalities/customsRebate/CustomsRebateProductType";
import BusinessPlanSectorActivity from "./views/formalities/businessPlan/BusinessPlanSectorActivity";
import BusinessPlanSectorActivityName from "./views/formalities/businessPlan/BusinessPlanSectorActivityName";
import BusinessPlanProjectName from "./views/formalities/businessPlan/BusinessPlanProjectName";
import VisualIdentity from "./views/formalities/visualIdentity/VisualIdentity";
import Trademark from "./views/formalities/trademark/Trademark";
import TaxRegistration from "./views/formalities/taxRegistration/TaxRegistration";
import TaxCompliance from "./views/formalities/taxCompliance/TaxCompliance";
import CnpsRegistration from "./views/formalities/cnpsRegistration/CnpsRegistration";
import ImportationBusinessAddress from "./views/formalities/importation/ImportationBusinessAddress";
import ImportationBusinessCountry from "./views/formalities/importation/ImportationBusinessCountry";
import ImportationBusinessName from "./views/formalities/importation/ImportationBusinessName";
import ImportationBusinessType from "./views/formalities/importation/ImportationBusinessType";
import ImportationCompanies from "./views/formalities/importation/ImportationCompanies";
import ImportationSectorActivity from "./views/formalities/importation/ImportationSectorActivity";
import ImportationSectorActivityName from "./views/formalities/importation/ImportationSectorActivityName";
import ImportationType from "./views/formalities/importation/ImportationType";
import AccountCheck from "./views/AccountCheck";
import LoginWorkflow from "./views/LoginWorkflow";
import FormalityLogin from "./views/formalities/FormalityLogin";
import FormalityAccountCheck from "./views/formalities/FormalityAccountCheck";
import OapiBusinessAddress from "./views/formalities/oapi/OapiBusinessAddress";
import OapiBusinessCountry from "./views/formalities/oapi/OapiBusinessCountry";
import OapiBusinessName from "./views/formalities/oapi/OapiBusinessName";
import OapiBusinessType from "./views/formalities/oapi/OapiBusinessType";
import OapiCompanies from "./views/formalities/oapi/OapiCompanies";
import OapiSectorActivity from "./views/formalities/oapi/OapiSectorActivity";
import OapiSectorActivityName from "./views/formalities/oapi/OapiSectorActivityName";
import PassportCountry from "./views/formalities/passport/PassportCountry";
import PassportType from "./views/formalities/passport/PassportType";
import PassportBirthPlace from "./views/formalities/passport/PassportBirthPlace";
import PassportResidencePlace from "./views/formalities/passport/PassportResidencePlace";
import PassportID from "./views/formalities/passport/PassportID";
import SalesLayout from "./layouts/SalesLayout";
import { RouteRobots } from "./components/seo/Seo";
import NotFound from "./views/NotFound";
import FaqPage from "./views/FaqPage";
import GuideIndex from "./views/guide/GuideIndex";
import GuideArticle from "./views/guide/GuideArticle";

const Pricing = lazy(() => import("./views/Princing"));

const preloadImages = (imageUrls) => {
  imageUrls.forEach((url, index) => {
    setTimeout(() => {
      // Étaler le chargement pour éviter un blocage
      const img = new Image();
      img.src = url;
    }, index * 100); // Attendre 100ms entre chaque image
  });
};

const imagesToPreload = [
  "/images/bank/bgfi.webp",
  "/images/bank/bi.webp",
  "/images/bank/afb.webp",
  "/images/bank/gb.webp",
  "/images/bank/scb.webp",
  "/images/bank/ecobank.webp",
  "/images/bank/uba.webp",
  "/images/bank/atlantique.webp",
  "/images/bank/commercial-bank.webp",
  "/images/bank/ubc.webp",
  "/images/domiciliation/administrative_and_tax_address.webp",
  "/images/domiciliation/mail_reception_and_sorting.webp",
  "/images/domiciliation/mail_scanning.webp",
  "/images/domiciliation/telephone_reception.webp",
  "/images/domiciliation/tax_localization.webp",
  "/images/gestion/preparing_quotes.webp",
  "/images/gestion/preparing_invoices.webp",
  "/images/gestion/personalized_secretary.webp",
  "/images/gestion/ERP.webp",
  "/images/administration/tax_accounting_tracking.webp",
  "/images/administration/monthly_e_filing.webp",
  "/images/administration/CNPS.webp",
  "/images/administration/tax_optimization.webp",
  "/images/grh/mail_reception.webp",
  "/images/grh/payroll.webp",
  "/images/grh/contract_termination_assistance.webp",
  "/images/juridique/professional_litigation.webp",
  "/images/juridique/business_contracts.webp",
  "/images/juridique/legal_secretary.webp",
  "/images/ventes/client_contact.webp",
  "/images/ventes/meeting_notes.webp",
  "/images/ventes/client_tracking.webp",
  "/images/ventes/client_follow.webp",
];

function App() {
  const { isAuthenticated, user } = useSelector((state) => state.authUser);

  useEffect(() => {
    // Attendre 2 secondes avant de commencer le préchargement
    setTimeout(() => preloadImages(imagesToPreload), 2000);
  }, []);

  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
            }}
          >
            <ScaleLoader
              color="#051259"
              loading={true}
              cssOverride={{
                display: "block",
                margin: "0 auto",
                borderColor: "red",
              }}
              size={30}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        }
      >
        <div className="App">
          <Banner />
          <RouteRobots />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/account-check" element={<AccountCheck />} />
            <Route path="/owner-information" element={<OwnerInformation />} />
            <Route path="/otp" element={<OTP />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login-workflow" element={<LoginWorkflow />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/forgot-password-email"
              element={<ForgotPasswordEmail />}
            />
            <Route path="/auth-otp" element={<AuthOPT />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/guide" element={<GuideIndex />} />
            <Route path="/guide/:slug" element={<GuideArticle />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />

            <Route path="/formality-login" element={<FormalityLogin />} />
            <Route
              path="/formality-account-check"
              element={<FormalityAccountCheck />}
            />
            <Route path="/formalities" element={<Formalities />} />
            <Route
              path="/formality-user-information"
              element={<FormalityUserInformation />}
            />
            <Route path="/formality-otp" element={<FormalityOTP />} />

            {/* authRoutes */}
            {isAuthenticated && (
              <>
                {user?.role === "admin" && (
                  <Route path="/admin/*" element={<AdminLayout />} />
                )}
                {user?.role === "user" && (
                  <Route path="/user/*" element={<UserLayout />} />
                )}
                {isOperator(user?.role) && (
                  <Route path="/operator/*" element={<OperatorLayout />} />
                )}
                {user?.role === "sales" && (
                  <Route path="/sales/*" element={<SalesLayout />} />
                )}
                {/* Workflows */}
                <Route path="/business-country" element={<BusinessCountry />} />
                <Route path="/business-type" element={<BusinessType />} />
                <Route
                  path="/associated-creators"
                  element={<AssociatedCreators />}
                />
                <Route path="/companies" element={<Companies />} />
                <Route path="/owner-status" element={<OwnerStatus />} />
                <Route path="/sector-activity" element={<SectorActivity />} />
                <Route
                  path="/sector-activity-name"
                  element={<SectorActivityName />}
                />
                <Route path="/procedure" element={<Procedure />} />
                <Route
                  path="/deadline"
                  element={<Navigate to="/procedure" replace />}
                />
                <Route
                  path="/have-business-name"
                  element={<HaveBusinessName />}
                />
                <Route path="/business-name" element={<BusinessName />} />
                <Route path="/oapi" element={<Oapi />} />
                <Route path="/company-seat" element={<CompanySeat />} />
                <Route path="/options" element={<Options />} />
                <Route path="/domiciliation" element={<Domiciliation />} />
                <Route path="/business-address" element={<BusinessAddress />} />
                <Route path="/bank" element={<Bank />} />
                <Route path="/other-services" element={<OtherServices />} />
                <Route path="/platform-gest" element={<PlatformGest />} />
                <Route path="/platform-admin" element={<PlatformAdmin />} />
                <Route path="/platform-grh" element={<PlatformGRH />} />
                <Route path="/platform-sale" element={<PlatformSale />} />
                <Route
                  path="/platform-juridique"
                  element={<PlatformJuridique />}
                />
                <Route path="/cart" element={<Cart />} />
                <Route path="/payment" element={<Payment />} />
                <Route path="/turnover" element={<Turnover />} />
                <Route path="/share-capital" element={<ShareCapital />} />
                <Route path="/platform-gest-2" element={<EditPlatformGest />} />
                <Route
                  path="/platform-admin-2"
                  element={<EditPlatformAdmin />}
                />
                <Route path="/platform-grh-2" element={<EditPlatformGRH />} />
                <Route path="/platform-sale-2" element={<EditPlatformSale />} />
                <Route
                  path="/platform-juridique-2"
                  element={<EditPlatformJuridique />}
                />
                <Route path="/oapi-2" element={<EditOapi />} />
                <Route
                  path="/domiciliation-2"
                  element={<EditDomiciliation />}
                />
                <Route path="/bank-2" element={<EditBank />} />
                <Route path="/business-name-2" element={<EditBusinessName />} />
                <Route
                  path="/have-business-name-2"
                  element={<EditHaveBusinessName />}
                />
                <Route path="/business-type-2" element={<EditBusinessType />} />
                <Route
                  path="/associated-creators-2"
                  element={<EditAssociatedCreators />}
                />
                <Route path="/finalization" element={<Finalization />} />
                <Route path="/check-payment" element={<CheckPayment />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/manager-type" element={<ManagerType />} />
                <Route path="/manager-name" element={<ManagerName />} />
                <Route
                  path="/manager-business-name"
                  element={<ManagerBusinessName />}
                />
                <Route
                  path="/owner-marital-status"
                  element={<OwnerMaritalStatus />}
                />
                {/* Formalities */}
                <Route
                  path="/formality-documents"
                  element={<FormalityDocuments />}
                />
                <Route
                  path="/formality-payment"
                  element={<FormalityPayment />}
                />
                <Route
                  path="/formality-finalization"
                  element={<FormalityFinalization />}
                />
                <Route path="/birth-place" element={<BirthPlace />} />
                <Route
                  path="/certificate-nationality-country"
                  element={<CertificateNationalityCountry />}
                />
                <Route
                  path="/certificate-singleness-country"
                  element={<CertificateSinglenessCountry />}
                />
                <Route path="/eneo-country" element={<EneoCountry />} />
                <Route
                  path="/eneo-electricity-meter-type"
                  element={<EneoElectricityMeterType />}
                />
                <Route
                  path="/customs-rebate-country"
                  element={<CustomsRebateCountry />}
                />
                /business-plan-sector-activity-name
                <Route
                  path="/customs-rebate-product-type"
                  element={<CustomsRebateProductType />}
                />
                <Route
                  path="/business-plan-sector-activity"
                  element={<BusinessPlanSectorActivity />}
                />
                <Route
                  path="/business-plan-sector-activity-name"
                  element={<BusinessPlanSectorActivityName />}
                />
                <Route
                  path="/business-plan-project-name"
                  element={<BusinessPlanProjectName />}
                />
                <Route path="/visual-identity" element={<VisualIdentity />} />
                <Route path="/trademark" element={<Trademark />} />
                <Route path="/tax-registration" element={<TaxRegistration />} />
                <Route path="/tax-compliance" element={<TaxCompliance />} />
                <Route
                  path="/cnps-registration"
                  element={<CnpsRegistration />}
                />
                <Route
                  path="/importation-business-address"
                  element={<ImportationBusinessAddress />}
                />
                <Route
                  path="/importation-business-country"
                  element={<ImportationBusinessCountry />}
                />
                <Route
                  path="/importation-business-name"
                  element={<ImportationBusinessName />}
                />
                <Route
                  path="/importation-business-type"
                  element={<ImportationBusinessType />}
                />
                <Route
                  path="/importation-companies"
                  element={<ImportationCompanies />}
                />
                <Route
                  path="/importation-sector-activity"
                  element={<ImportationSectorActivity />}
                />
                <Route
                  path="/importation-sector-activity-name"
                  element={<ImportationSectorActivityName />}
                />
                <Route path="/importation-type" element={<ImportationType />} />
                <Route
                  path="/oapi-business-address"
                  element={<OapiBusinessAddress />}
                />
                <Route
                  path="/oapi-business-country"
                  element={<OapiBusinessCountry />}
                />
                <Route
                  path="/oapi-business-name"
                  element={<OapiBusinessName />}
                />
                <Route
                  path="/oapi-business-type"
                  element={<OapiBusinessType />}
                />
                <Route path="/oapi-companies" element={<OapiCompanies />} />
                <Route
                  path="/oapi-sector-activity"
                  element={<OapiSectorActivity />}
                />
                <Route
                  path="/oapi-sector-activity-name"
                  element={<OapiSectorActivityName />}
                />
                <Route path="/passport-country" element={<PassportCountry />} />
                <Route path="/passport-type" element={<PassportType />} />
                <Route
                  path="/passport-birth-place"
                  element={<PassportBirthPlace />}
                />
                <Route
                  path="/passport-residence-place"
                  element={<PassportResidencePlace />}
                />
                <Route path="/passport-id" element={<PassportID />} />
              </>
            )}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Suspense>
    </Router>
  );
}

export default App;
